import { getPageUrl } from '@/utils/helpers';

const resolveReference = <T = unknown>({
  rawVal,
  page,
}: PropsWithCMSProps<ReferenceProps>): T | undefined => {
  const content = rawVal?.$ref ? page?.getContent(rawVal) : undefined;
  const url = content?.getUrl?.();
  return content
    ? ({
        ...content.getData?.(),
        url: url && page ? getPageUrl({ url, page }) : '',
      } as T)
    : undefined;
};

export default resolveReference;
